module.exports = __webpack_public_path__ + "img/d4.1cd0ac61.png";